import { Box, IconButton, Stack, styled, Typography, Theme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';

import NextPageArrow from '../../assets/icons/arrowNextPage.svg?react';
import DiscountCarIcon from '../../assets/icons/discountCarIcon.svg?react';
import { useDiscount } from '../../hooks/useDiscount';
import { useTranslation } from 'react-i18next';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.gray.main,
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.gray.main,
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.green.main,
    ...theme.applyStyles('dark', {
      backgroundColor: '#308fe8',
    }),
  },
}));

export const Discount = () => {
  const navigate = useNavigate();
  const { currentUserDiscountRange } = useDiscount();
  const { t } = useTranslation();

  const completionPercentage = currentUserDiscountRange?.completionPercentage;

  return (
    <Stack sx={{ width: '100%', gap: '4px' }}>
      <Stack
        direction="row"
        sx={{ alignItems: 'center', justifyContent: 'space-between' }}
      >
        <Typography variant="body2" color="common.white">
          {t('cabinetPage.currentDiscountRangeText')}:{' '}
          {currentUserDiscountRange?.discount || 0}%
        </Typography>
        <IconButton
          id="basic-button"
          onClick={() => navigate(`${ROUTES.LOYALTY}`)}
        >
          <NextPageArrow />
        </IconButton>
      </Stack>
      <Box
        sx={(theme: Theme) => ({
          padding: '27px 17px',
          borderRadius: '15px',
          border: '1px solid',
          borderColor: theme.palette.gray[150],
        })}
      >
        <Stack sx={{ position: 'relative' }}>
          <DiscountCarIcon
            width={30}
            height={30}
            style={{
              position: 'absolute',
              left: `${completionPercentage}%`,
              top: '-280%',
              transform: 'translateX(-50%)',
            }}
          />
          <BorderLinearProgress
            variant="determinate"
            value={completionPercentage || 0}
          />
          <Typography
            variant="body2"
            color="common.white"
            sx={{ position: 'absolute', right: 0, bottom: '-200%' }}
          >
            {completionPercentage || 0}%
          </Typography>
        </Stack>
      </Box>
    </Stack>
  );
};
